/**
 * Base implementation of low-level transport. Each low-level transport should implement following methods:
 * <ul>
 *     <li>send(endpoint : String, headers: {}, method : String, params : *[]) : Promise<Object> - performs a network query. </li>
 * </ul>
 */
import generateGuid from 'uuid/v4';
import q from 'q';

export default {
    send: function send(endpoint, headers, method, params) {
        var requestCode = generateGuid();
        var deferred = q.defer();
        console.log("In module.js --> send()" + params);
        console.log("Method -->" + method);
        console.log("Endpoint -->" + endpoint);
        var baseHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json;',
            'Authorization': 'Baic YWFyb24uYmVhcmQ6QmVyYW5lcnJlZQ=='
        };
        headers = Object.assign(baseHeaders, headers);
        return fetch(endpoint, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                'id': '' + requestCode,
                'jsonrpc': '2.0',
                method: method,
                params: params
            })
        }).then(function (res) {
            console.log('inside result-->');
            console.log(res);
            console.log('method name ==> ' + method);
            console.log(JSON.stringify(res));
            if (!res.ok) {
                //commenting the below login redirection for DEF1248
                // Fix for Defect 0455 - to ensure PC down displays the error message
                //window.location.hash = '#/auth/login';
                console.log('res is NOT ok.');
                // check if the error is due to get Current user or check Pc availability...
                if ((method === 'getCurrentUser' || method === 'checkPcAvailability') && res.status >= 500 && res.status < 505) {
                    deferred.reject({
                        id: 1,
                        error: res.status + " : " + res.statusText
                    });

                    return deferred.promise;
                }
                if ((method === 'submitPayrollReportData' || method === 'getPayrollDataForPeriod' || method === 'submitOneTimePayrollReportData') && res.status === 502) {
                    console.log("inside submit payroll method");
                    console.log(res.status);
                    deferred.reject({
                        id: 1,
                        error: res.status + " : " + res.statusText
                    });

                    return deferred.promise;
                }
                //setting up error data if service fails due to other reasons
                return res.json().then(function (data) {
                    deferred.reject({
                        id: data.id,
                        error: data.error
                    });
                    return deferred.promise;
                });
            }

            if (method === 'checkPcAvailability' && res.status === 200) {
                console.log('Connecting to PC');
                deferred.resolve({
                    status: res.status,
                    message: res.statusText
                });
                return deferred.promise;
            }
            return res.json().then(function (data) {
                deferred.resolve({
                    id: data.id,
                    result: data.result
                });
                return deferred.promise;
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-transport-js/module.js
// module id = 323
// module chunks = 0